export enum Role {
  OrganizationOwner = 'organizationOwner',
  OrganizationAdmin = 'organizationAdmin',
  OrganizationViewer = 'organizationViewer',
  ProjectAdmin = 'projectAdmin',
  ProjectViewer = 'projectViewer',
}

export interface RolesPermissions {
  organizationOwner: boolean;
  organizationAdmin: boolean;
  organizationViewer: boolean;
  projectAdmin: boolean;
  projectViewer: boolean;
}
